export const gameRaces = {
  "primer-bloque": {
    "espada-sagrada": [
      { id: 1, name: "Caballero", slug: "caballero", emoji: "🛡️" },
      { id: 5, name: "Dragón", slug: "dragon", emoji: "🐉" },
      { id: 7, name: "Faerie", slug: "faerie", emoji: "🧚" },
      { id: 27, name: "Faerie / Goblin", slug: "faerie", emoji: "🧚" },
    ],
    helenica: [
      { id: 9, name: "Héroe", slug: "heroe", emoji: "⚔️" },
      { id: 8, name: "Olímpico", slug: "olimpico", emoji: "🏛️" },
      { id: 10, name: "Titán", slug: "titan", emoji: "🗿" },
      { id: 28, name: "Titán / Minotauro", slug: "titan", emoji: "🗿" },
    ],
    "hijos-daana": [
      { id: 12, name: "Defensor", slug: "defensor", emoji: "🛡️" },
      { id: 29, name: "Defensor / Druida", slug: "defensor", emoji: "🛡️" },
      { id: 11, name: "Desafiante", slug: "desafiante", emoji: "🔥" },
      { id: 3, name: "Sombra", slug: "sombra", emoji: "🕶️" },
      { id: 30, name: "Sombra / Drácula", slug: "sombra", emoji: "🕶️" },
    ],
    "dominios-ra": [
      { id: 6, name: "Eterno", slug: "eterno", emoji: "♾️" },
      { id: 13, name: "Faraón", slug: "faraon", emoji: "🪬" },
      { id: 34, name: "Faraón / Guerrero", slug: "faraon", emoji: "🪬" },
      { id: 14, name: "Sacerdote", slug: "sacerdote", emoji: "⛪" },
    ],
  },
  "primera-era": {
    "el-reto": [
      { id: 1, name: "Caballero", slug: "caballero", emoji: "🛡️" },
      { id: 5, name: "Dragón", slug: "dragon", emoji: "🐉" },
      { id: 7, name: "Faerie", slug: "faerie", emoji: "🧚" },
    ],
    "mundo-gotico": [
      { id: 15, name: "Cazador", slug: "cazador", emoji: "🏹" },
      { id: 16, name: "Licántropo", slug: "licantropo", emoji: "🐺" },
      { id: 17, name: "Vampiro", slug: "vampiro", emoji: "🧛" },
    ],
    "ira-nahual": [
      { id: 4, name: "Bestia", slug: "bestia", emoji: "🐾" },
      { id: 18, name: "Chamán", slug: "chaman", emoji: "🪶" },
      { id: 2, name: "Guerrero", slug: "guerrero", emoji: "⚔️" },
    ],
    ragnarok: [
      { id: 19, name: "Abominación", slug: "abominacion", emoji: "👹" },
      { id: 20, name: "Bárbaro", slug: "barbaro", emoji: "🪓" },
      { id: 21, name: "Dios", slug: "dios", emoji: "⚡" },
    ],
    "espiritu-dragon": [
      { id: 22, name: "Campeón", slug: "campeon", emoji: "🏆" },
      { id: 23, name: "Criaturas", slug: "criaturas", emoji: "👾" },
      { id: 24, name: "Kami", slug: "kami", emoji: "🌀" },
      { id: 25, name: "Xian", slug: "xian", emoji: "🎎" },
    ],
  },
  "furia-extendido": [
    { id: 1, name: "Caballero", slug: "caballero", emoji: "🛡️" },
    { id: 7, name: "Faerie", slug: "faerie", emoji: "🧚" },
    { id: 6, name: "Eterno", slug: "eterno", emoji: "♾️" },
    { id: 5, name: "Dragón", slug: "dragon", emoji: "🐉" },
    { id: 2, name: "Guerrero", slug: "guerrero", emoji: "⚔️" },
    { id: 3, name: "Sombra", slug: "sombra", emoji: "🕶️" },
    { id: 14, name: "Sacerdote", slug: "sacerdote", emoji: "⛪" },
    { id: 9, name: "Héroe", slug: "heroe", emoji: "✨" },
    { id: 35, name: "Ancestral", slug: "ancestral", emoji: "🗿" },
  ],
  imperio: [
    { id: 1, name: "Caballero", slug: "caballero", emoji: "🛡️" },
    { id: 5, name: "Dragón", slug: "dragon", emoji: "🐉" },
    { id: 6, name: "Eterno", slug: "eterno", emoji: "♾️" },
    { id: 3, name: "Sombra", slug: "sombra", emoji: "🕶️" },
    { id: 2, name: "Guerrero", slug: "guerrero", emoji: "⚔️" },
    { id: 9, name: "Héroe", slug: "heroe", emoji: "✨" },
    { id: 4, name: "Bestia", slug: "bestia", emoji: "🐾" },
    { id: 14, name: "Sacerdote", slug: "sacerdote", emoji: "⛪" },
    { id: 7, name: "Faerie", slug: "faerie", emoji: "🧚" },
  ],
}

function flattenRacesToMap(obj: unknown) {
  const map = new Map<number, string>()

  function recurse(value: unknown) {
    if (Array.isArray(value)) {
      value.forEach((race) => {
        if (!map.has(race.id)) {
          map.set(race.id, race.name)
        }
      })
    } else if (typeof value === "object" && value !== null) {
      Object.values(value).forEach(recurse)
    }
  }

  recurse(obj)
  return map
}

export const RacesMap = flattenRacesToMap(gameRaces)
